export default __webpack_public_path__ + "static/media/playday.aba93f9c.jpg";